import React from 'react';
import './Hero.css';

const Hero = () => {
  return (
    <section className="hero">
      <div className="hero-cover">
        <img 
          src="/mega_cover.png" 
          alt="MegaGenie - Genie at your service in line with online retail"
          className="hero-cover-image"
        />
      </div>
    </section>
  );
};

export default Hero;
